"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var PercentageLabelValue_1 = require("./PercentageLabelValue");
var paymentRatesStyles_1 = require("./paymentRatesStyles");
var react_intl_1 = require("react-intl");
var gqlPriceFormatter_1 = require("../../../../common/hooks/prices/gqlPriceFormatter");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var IndicativeNumber_1 = require("../../../../common/components/indicativeNumber/IndicativeNumber");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var PaymentRates = function (_a) {
    var financeSimulation = _a.financeSimulation;
    var _b, _c, _d, _e, _f, _g;
    var _h = financeSimulation || {}, amountFinanced = _h.amountFinanced, interestRate = _h.interestRate, comparisonRate = _h.comparisonRate, frequency = _h.frequency, paymentValue = _h.paymentValue, loanTermPeriod = _h.loanTermPeriod;
    var _j = usePlatformConfig_1.default().platformConfig.priceDisplay, primaryOptions = _j.primaryOptions, secondaryOptions = _j.secondaryOptions;
    var styles = paymentRatesStyles_1.default();
    var decimalScale = ((_b = secondaryOptions) === null || _b === void 0 ? void 0 : _b.decimalScale) || 1;
    if (((_c = paymentValue) === null || _c === void 0 ? void 0 : _c.length) && ((_d = paymentValue[0]) === null || _d === void 0 ? void 0 : _d.currency) === ((_e = primaryOptions) === null || _e === void 0 ? void 0 : _e.currency)) {
        decimalScale = ((_f = primaryOptions) === null || _f === void 0 ? void 0 : _f.decimalScale) || 1;
    }
    var priceDenominator = Math.pow(10, decimalScale);
    var repaymentPrice = gqlPriceFormatter_1.gqlPriceFormatter().format((paymentValue && ((_g = paymentValue[0]) === null || _g === void 0 ? void 0 : _g.amount) / priceDenominator) || 0);
    var totalAmountRepayable = gqlPriceFormatter_1.gqlPriceFormatter().format((amountFinanced && amountFinanced[0].amount / priceDenominator) || 0);
    var intl = react_intl_1.useIntl();
    if (!financeSimulation) {
        return null;
    }
    return (<core_1.Box className={styles.container}>
      <core_1.Box data-test="calculator:payment-summary" className={styles.summaryRoot}>
        <core_1.Typography component="h2" className={styles.title} data-test="financeBlock:title">
          <Translation_1.default id="trans__checkout__confirmation_page__summary__finance_payment_label"/>
        </core_1.Typography>
        <core_1.Box className={styles.paymentRatesGridRoot}>
          <core_1.Box display="flex" alignItems="center">
            <PercentageLabelValue_1.default percentageData={{
        titleClassName: styles.repaymentDuration,
        value: repaymentPrice,
        title: 'trans__checkout__confirmation_page__summary__finance_payment_details',
        titleValues: {
            frequency: intl.formatMessage({ id: frequency }),
            duration: loanTermPeriod.value,
        },
    }} percentageLabel={{
        title: 'trans__checkout__confirmation_page__summary__total_payment',
        titleValues: {
            total: totalAmountRepayable,
        },
    }} indicativeNumber="trans__checkout__vehicle_details__price_with_finance__indicative_repayment" dataTest="financeBlock:repaymentPrice"/>
          </core_1.Box>
          <core_1.Grid container={true}>
            <PercentageLabelValue_1.default percentageData={{
        value: (interestRate || 0).toFixed(decimalScale),
        titleClassName: styles.rpaLabel,
        title: 'trans__checkout__confirmation_page__summary__finance_payment_pa_label',
    }} percentageLabel={{
        title: 'trans__checkout__confirmation_page__summary__finance_payment_interest_rate_label',
    }} indicativeNumber="trans__checkout__vehicle_details__price_with_finance__indicative_interest_rate" dataTest="financeBlock:interestRate"/>
            <PercentageLabelValue_1.default className={styles.comparisonRate} percentageData={{
        titleClassName: styles.rpaLabel,
        value: (comparisonRate || 0).toFixed(decimalScale),
        title: 'trans__checkout__confirmation_page__summary__finance_payment_pa_label',
    }} percentageLabel={{
        title: 'trans__checkout__confirmation_page__summary__finance_payment_comparison_rate_label',
    }} indicativeNumber="trans__checkout__vehicle_details__price_with_finance__indicative_comparison_rate" dataTest="financeBlock:comparisonRate"/>
            <core_1.Grid item={true} xs={12} data-test="calculator:payment-description">
              <core_1.Typography component="span" className={styles.paymentRatesPercentageLabel} data-test="financeBlock:description">
                <Translation_1.default id="trans__checkout__confirmation_page__summary__finance_payment_details_disclaimer"/>
                <IndicativeNumber_1.default value="trans__checkout__vehicle_details__price_with_finance__indicative_interest_rate"/>
              </core_1.Typography>
            </core_1.Grid>
          </core_1.Grid>
        </core_1.Box>
      </core_1.Box>
    </core_1.Box>);
};
exports.default = PaymentRates;
